/** Source dictionary; `en.ts` must have the same shape. Plural entries use Intl.PluralRules categories. */
export const ru = {
  common: {
    appName: 'miroom',
    loading: 'Загрузка…',
    retry: 'Повторить',
    cancel: 'Отмена',
    save: 'Сохранить',
    saved: 'Сохранено',
    delete: 'Удалить',
    close: 'Закрыть',
    copy: 'Копировать',
    copied: 'Скопировано',
    back: 'Назад',
    search: 'Поиск',
    more: 'Ещё',
    done: 'Готово',
    or: 'или',
  },
  errors: {
    network: 'Нет связи с сервером. Проверьте подключение.',
    internal: 'Что-то пошло не так. Попробуйте ещё раз.',
    unauthorized: 'Нужно войти в аккаунт.',
    forbidden: 'Недостаточно прав.',
    not_found: 'Не найдено.',
    rate_limited: 'Слишком много попыток. Подождите минуту.',
    validation: 'Проверьте введённые данные.',
    link_invalid: 'Ссылка устарела или уже использована. Запросите новую.',
    mail_failed: 'Не удалось отправить письмо. Попробуйте чуть позже.',
    payload_too_large: 'Файл слишком большой.',
    unsupported_media: 'Неподдерживаемый формат файла.',
    conflict: 'Конфликт данных.',
  },
  theme: { label: 'Тема', system: 'Как в системе', light: 'Светлая', dark: 'Тёмная' },
  locale: { label: 'Язык', ru: 'Русский', en: 'English' },
  nav: {
    login: 'Войти',
    register: 'Регистрация',
    logout: 'Выйти',
    boards: 'Мои доски',
    settings: 'Профиль и настройки',
    startFree: 'Начать бесплатно',
  },
  auth: {
    loginTitle: 'С возвращением',
    loginSubtitle: 'Пришлём ссылку для входа на вашу почту — без пароля',
    registerTitle: 'Создайте аккаунт',
    registerSubtitle: 'Бесплатно и без ограничений по количеству досок',
    name: 'Имя',
    namePlaceholder: 'Как вас называть',
    email: 'Email',
    emailHint: 'На этот адрес придёт ссылка для входа',
    submitLogin: 'Получить ссылку для входа',
    submitRegister: 'Создать аккаунт',
    noAccount: 'Нет аккаунта?',
    haveAccount: 'Уже есть аккаунт?',
    toRegister: 'Зарегистрироваться',
    toLogin: 'Войти',
    nameRequired: 'Введите имя',
    emailInvalid: 'Введите корректный email',
    asideTitle: 'Думайте вместе на бесконечной доске',
    asideText: 'Стикеры, схемы, mind map, голосование и живые курсоры всей команды.',
    note1: '💡 Идеи',
    note2: '🗳 Голосуем!',
    note3: '🚀 Запуск',
    checkEmailTitle: 'Проверьте почту',
    checkEmailText: 'Мы отправили уникальную ссылку для входа на',
    noLink: 'Письмо не пришло?',
    resend: 'Отправить ещё раз',
    resendIn: 'Отправить ещё раз через {n} с',
    noLinkHint: '. Загляните в «Спам». Ссылка одноразовая и действует 30 минут.',
    linkResent: 'Ссылка отправлена повторно',
    changeEmail: 'Указать другой email',
    linkInvalidTitle: 'Не удалось войти',
    requestNewLink: 'Запросить новую ссылку',
  },
  dashboard: {
    title: 'Доски',
    newBoard: 'Новая доска',
    searchPlaceholder: 'Поиск досок',
    import: 'Импорт из файла',
    importFailed: 'Не удалось импортировать: файл не похож на доску miroom',
    tabs: {
      recent: 'Недавние',
      mine: 'Мои доски',
      shared: 'Доступные мне',
      starred: 'Избранное',
      trash: 'Корзина',
    },
    sort: 'Сортировка',
    sortDate: 'По дате',
    sortName: 'По имени',
    quickStart: 'Быстрый старт',
    allTemplates: 'Все шаблоны',
    edited: 'Изменено {time}',
    deletedAt: 'Удалено {time}',
    by: 'Владелец: {name}',
    star: 'Добавить в избранное',
    unstar: 'Убрать из избранного',
    actions: 'Действия с доской',
    open: 'Открыть',
    openNewTab: 'Открыть в новой вкладке',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    duplicated: 'Создана копия «{title}»',
    moveToTrash: 'В корзину',
    leave: 'Покинуть доску',
    restore: 'Восстановить',
    deleteForever: 'Удалить навсегда',
    movedToTrash: 'Доска перемещена в корзину',
    left: 'Вы покинули доску',
    undo: 'Отменить',
    restored: 'Доска восстановлена',
    deleteForeverTitle: 'Удалить навсегда?',
    deleteForeverText:
      'Доска «{title}» и вся её история будут удалены без возможности восстановления.',
    renameTitle: 'Переименовать доску',
    boardName: 'Название',
    trashHint: 'Доски в корзине удаляются навсегда через 30 дней.',
    loadError: 'Не удалось загрузить доски',
    empty: {
      recent: 'Здесь появятся доски, которые вы открывали',
      mine: 'У вас пока нет досок',
      shared: 'С вами пока никто не поделился досками',
      starred: 'Отмечайте доски звёздочкой, чтобы быстро их находить',
      trash: 'Корзина пуста',
      search: 'Ничего не найдено по запросу «{q}»',
      cta: 'Создайте первую доску — это займёт секунду',
    },
  },
  templates: {
    title: 'Создать доску',
    subtitle: 'Начните с чистого листа или готового шаблона',
    creating: 'Создаём доску…',
    blank: { name: 'Пустая доска', desc: 'Бесконечный холст для любых идей' },
    retro: { name: 'Ретроспектива', desc: 'Начать / Перестать / Продолжать' },
    kanban: { name: 'Канбан', desc: 'Колонки задач от бэклога до готово' },
    mindmap: { name: 'Mind map', desc: 'Ветвящиеся идеи вокруг центральной темы' },
    storymap: { name: 'User Story Map', desc: 'Путь пользователя и истории по релизам' },
    swot: { name: 'SWOT-анализ', desc: 'Сильные и слабые стороны, возможности, угрозы' },
    lean: { name: 'Lean Canvas', desc: 'Бизнес-модель на одном листе' },
    roadmap: { name: 'Роадмап', desc: 'Инициативы по кварталам и командам' },
    flowchart: { name: 'Блок-схема', desc: 'Процесс с условиями и ветвлениями' },
    brainstorm: { name: 'Мозговой штурм', desc: 'Вопрос в центре и стикеры вокруг' },
    weekly: { name: 'План недели', desc: 'Дни недели для личного или командного плана' },
  },
  time: { justNow: 'только что' },
  board: {
    loading: 'Загрузка доски…',
    connecting: 'Подключение…',
    offline: 'Нет соединения. Изменения сохранятся и отправятся при подключении.',
    readOnly: 'Только просмотр',
    commentOnly: 'Только комментирование',
    notFoundTitle: 'Доска не найдена',
    notFoundText: 'Возможно, её удалили или ссылка неверна.',
    noAccessTitle: 'Нет доступа к доске',
    noAccessText: 'Попросите владельца пригласить вас или открыть доступ по ссылке.',
    loginTitle: 'Войдите, чтобы открыть доску',
    loginText: 'Эта доска доступна только участникам.',
    toDashboard: 'К моим доскам',
    emptyHint: 'Двойной клик — новый стикер. Или выберите инструмент слева.',
    untitled: 'Без названия',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    zoomReset: 'Масштаб 100%',
    zoomFit: 'Показать всё',
    backToBoards: 'К списку досок',
    guestName: 'Гость',
    editText: 'Редактирование текста',
    cardTitle: 'Название задачи',
    cardDescription: 'Описание',
    uploading: 'Загрузка изображения… {pct}%',
    dropHere: 'Отпустите, чтобы добавить изображения',
    canvasLabel: 'Холст доски',
    viewerHint: 'Доска пуста.',
    renameBoard: 'Переименовать доску',
  },
  tools: {
    label: 'Инструменты',
    select: 'Выделение (V)',
    hand: 'Рука (H, пробел)',
    sticky: 'Стикер (N)',
    text: 'Текст (T)',
    shape: 'Фигура (S)',
    connector: 'Линия (L)',
    pen: 'Перо (P)',
    marker: 'Маркер',
    eraser: 'Ластик (E)',
    frame: 'Фрейм (F)',
    image: 'Изображение',
    card: 'Карточка',
    table: 'Таблица',
    mindmap: 'Mind map (M)',
    comment: 'Комментарий (C)',
    emoji: 'Эмодзи',
    laser: 'Лазерная указка (K)',
    more: 'Ещё инструменты',
    undo: 'Отменить (Ctrl+Z)',
    redo: 'Повторить (Ctrl+Shift+Z)',
    penColor: 'Цвет',
    penWidth: 'Толщина',
    frameDefault: 'Фрейм',
    stickyColor: 'Цвет стикера',
    shapes: {
      rect: 'Прямоугольник',
      roundRect: 'Скруглённый',
      ellipse: 'Эллипс',
      diamond: 'Ромб',
      triangle: 'Треугольник',
      parallelogram: 'Параллелограмм',
      star: 'Звезда',
      hexagon: 'Шестиугольник',
      arrowBlock: 'Стрелка',
      cylinder: 'Цилиндр',
      callout: 'Выноска',
    },
  },
  props: {
    label: 'Свойства объекта',
    color: 'Цвет',
    fill: 'Заливка',
    stroke: 'Обводка',
    textColor: 'Цвет текста',
    transparent: 'Без заливки',
    fontSize: 'Размер шрифта',
    auto: 'Авто',
    font: 'Шрифт',
    fonts: { sans: 'Без засечек', serif: 'С засечками', mono: 'Моноширинный', hand: 'Рукописный' },
    bold: 'Жирный (Ctrl+B)',
    italic: 'Курсив (Ctrl+I)',
    underline: 'Подчёркнутый (Ctrl+U)',
    strike: 'Зачёркнутый',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    strokeWidth: 'Толщина линии',
    strokeStyle: 'Стиль линии',
    solid: 'Сплошная',
    dashed: 'Пунктир',
    dotted: 'Точки',
    shape: 'Тип фигуры',
    textSettings: 'Текст',
    route: 'Тип линии',
    routes: { straight: 'Прямая', elbow: 'Ломаная', curved: 'Кривая' },
    startCap: 'Начало линии',
    endCap: 'Конец линии',
    caps: {
      none: 'Нет',
      arrow: 'Стрелка',
      triangle: 'Треугольник',
      circle: 'Круг',
      diamond: 'Ромб',
    },
    swapEnds: 'Поменять направление',
    cardColor: 'Цвет карточки',
    assignee: 'Исполнитель',
    dueDate: 'Срок',
    addRow: 'Добавить строку',
    addColumn: 'Добавить столбец',
    removeRow: 'Удалить строку',
    removeColumn: 'Удалить столбец',
    headerRow: 'Строка заголовка',
    addChild: 'Добавить дочерний узел (Tab)',
    addSibling: 'Добавить соседний узел (Enter)',
    collapse: 'Свернуть ветку',
    expand: 'Развернуть ветку',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    delete: 'Удалить (Del)',
    edit: 'Редактировать текст',
  },
  menu: {
    bringToFront: 'На передний план',
    bringForward: 'Выше',
    sendBackward: 'Ниже',
    sendToBack: 'На задний план',
    group: 'Сгруппировать',
    ungroup: 'Разгруппировать',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    align: 'Выравнивание',
    alignLeft: 'По левому краю',
    alignHCenter: 'По центру (гор.)',
    alignRight: 'По правому краю',
    alignTop: 'По верхнему краю',
    alignVMiddle: 'По центру (верт.)',
    alignBottom: 'По нижнему краю',
    distributeH: 'Распределить по горизонтали',
    distributeV: 'Распределить по вертикали',
    delete: 'Удалить',
    copy: 'Копировать',
    cut: 'Вырезать',
    paste: 'Вставить',
    duplicate: 'Дублировать',
    selectAll: 'Выделить всё',
    snapToGrid: 'Привязка к сетке',
    snapToGridOff: 'Привязка к сетке (включите сетку в меню доски)',
    copyLink: 'Ссылка на объект',
  },
  presence: {
    online: 'Сейчас на доске',
    you: 'Вы',
    follow: 'Следовать за {name}',
    following: 'Вы следите за {name}',
    stopFollowing: 'Остановить',
    summon: 'Позвать всех ко мне',
    summoned: '{name} позвал(а) всех к себе',
    summonSent: 'Все участники переместились к вам',
    react: 'Реакция',
    chatPlaceholder: 'Сообщение… (Enter)',
    connected: 'Подключено',
    connecting: 'Подключение…',
    offline: 'Нет соединения',
  },
  comments: {
    title: 'Комментарии',
    placeholder: 'Напишите комментарий…',
    replyPlaceholder: 'Ответить…',
    send: 'Отправить',
    resolve: 'Решено',
    reopen: 'Открыть снова',
    delete: 'Удалить',
    deleteThread: 'Удалить обсуждение',
    showResolved: 'Показывать решённые',
    empty: 'Пока нет комментариев. Выберите инструмент «Комментарий» (C) и кликните по доске.',
    open: 'Открытые',
    resolved: 'Решённые',
    replies: { one: '{n} ответ', few: '{n} ответа', many: '{n} ответов', other: '{n} ответа' },
    pin: 'Комментарий от {name}',
    newPin: 'Новый комментарий',
  },
  facilitation: {
    timer: 'Таймер',
    timerPresets: 'Запустить таймер',
    minutes: { one: '{n} минута', few: '{n} минуты', many: '{n} минут', other: '{n} минуты' },
    pause: 'Пауза',
    resume: 'Продолжить',
    plusMinute: '+1 минута',
    stop: 'Остановить',
    timeUp: 'Время вышло!',
    voting: 'Голосование',
    startVoting: 'Начать голосование',
    votesPerUser: 'Голосов на участника',
    duration: 'Длительность',
    noLimit: 'Без ограничения',
    votingHint: 'Участники кликают по объектам, чтобы отдать голос. Повторный клик снимает голос.',
    votesLeft: {
      one: 'Остался {n} голос',
      few: 'Осталось {n} голоса',
      many: 'Осталось {n} голосов',
      other: 'Осталось {n} голоса',
    },
    endVoting: 'Завершить',
    results: 'Итоги голосования',
    voters: {
      one: 'Проголосовал {n} участник',
      few: 'Проголосовали {n} участника',
      many: 'Проголосовали {n} участников',
      other: 'Проголосовали {n} участника',
    },
    noVotes: 'Голосов пока нет',
    closeResults: 'Закрыть итоги',
    votesExhausted: 'Голоса закончились — снимите голос, кликнув по объекту ещё раз',
    votingStarted: 'Голосование началось: кликайте по объектам',
    object: 'Объект',
  },
  present: {
    frames: 'Фреймы',
    start: 'Презентация',
    startFrom: 'Показать с этого фрейма',
    empty: 'На доске нет фреймов. Добавьте фрейм (F), чтобы показывать доску как презентацию.',
    prev: 'Назад (←)',
    next: 'Далее (→)',
    exit: 'Выйти (Esc)',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    counter: '{i} из {n}',
  },
  share: {
    button: 'Поделиться',
    title: 'Поделиться доской',
    linkAccess: 'Доступ по ссылке',
    linkNone: 'Только приглашённые',
    linkView: 'Все, у кого есть ссылка, могут смотреть',
    linkComment: 'Все, у кого есть ссылка, могут комментировать',
    linkEdit: 'Все, у кого есть ссылка, могут редактировать',
    copyLink: 'Копировать ссылку',
    linkCopied: 'Ссылка скопирована',
    invite: 'Пригласить по email',
    inviteButton: 'Пригласить',
    invited: '{name} получил(а) доступ',
    userNotFound: 'Пользователь с таким email не зарегистрирован в miroom',
    ownerAlready: 'Это владелец доски',
    members: 'Участники',
    roles: {
      owner: 'Владелец',
      editor: 'Редактор',
      commenter: 'Комментатор',
      viewer: 'Наблюдатель',
    },
    remove: 'Убрать доступ',
    you: 'вы',
    readOnlyHint: 'Управлять доступом могут владелец и редакторы.',
  },
  guest: {
    title: 'Как вас представить?',
    text: 'Ваше имя увидят другие участники доски.',
    name: 'Имя',
    join: 'Войти на доску',
    or: 'Есть аккаунт?',
    login: 'Войти',
    banner: 'Вы гость. Войдите, чтобы доска появилась в вашем списке.',
  },
  revoked: {
    title: 'Доступ к доске закрыт',
    text: 'Владелец изменил настройки доступа или доска была удалена.',
  },
  versions: {
    title: 'История версий',
    save: 'Сохранить версию',
    namePlaceholder: 'Название версии',
    auto: 'Автосохранение',
    beforeRestore: 'Перед восстановлением',
    restore: 'Восстановить',
    restoreConfirm: 'Доска вернётся к версии «{name}». Текущее состояние сохранится в истории.',
    restored: 'Версия восстановлена',
    saved: 'Версия сохранена',
    empty: 'Версий пока нет. Они создаются автоматически во время работы.',
    preview: 'Предпросмотр',
    loadError: 'Не удалось загрузить историю',
  },
  boardMenu: {
    label: 'Меню доски',
    history: 'История версий',
    grid: 'Показывать сетку',
    exportPng: 'Экспорт в PNG',
    exportSelection: 'Экспорт выделения в PNG',
    exportSvg: 'Экспорт в SVG',
    exportPdf: 'Экспорт в PDF (по фреймам)',
    exportJson: 'Резервная копия (JSON)',
    exporting: 'Готовим файл…',
    exportEmpty: 'Доска пуста — экспортировать нечего',
    duplicate: 'Создать копию доски',
    duplicated: 'Копия создана',
  },
  search: {
    title: 'Поиск по доске',
    placeholder: 'Найти текст на доске',
    empty: 'Ничего не найдено',
    types: {
      sticky: 'Стикер',
      text: 'Текст',
      shape: 'Фигура',
      connector: 'Линия',
      drawing: 'Рисунок',
      image: 'Изображение',
      frame: 'Фрейм',
      card: 'Карточка',
      table: 'Таблица',
      mindmap: 'Mind map',
      emoji: 'Эмодзи',
    },
    hint: 'Ищет в стикерах, тексте, фигурах, карточках, таблицах и фреймах.',
    count: {
      one: '{n} совпадение',
      few: '{n} совпадения',
      many: '{n} совпадений',
      other: '{n} совпадения',
    },
  },
  minimap: { label: 'Мини-карта', show: 'Показать мини-карту', hide: 'Скрыть мини-карту' },
  help: {
    title: 'Горячие клавиши',
    button: 'Горячие клавиши (?)',
    groups: {
      tools: 'Инструменты',
      edit: 'Редактирование',
      view: 'Навигация',
      collab: 'Совместная работа',
    },
    items: {
      select: 'Выделение',
      hand: 'Рука / пан',
      sticky: 'Стикер',
      text: 'Текст',
      shape: 'Фигура',
      rect: 'Прямоугольник',
      ellipse: 'Эллипс',
      line: 'Линия',
      pen: 'Перо',
      eraser: 'Ластик',
      frame: 'Фрейм',
      mindmap: 'Mind map',
      comment: 'Комментарий',
      laser: 'Лазер',
      undo: 'Отменить',
      redo: 'Повторить',
      copy: 'Копировать',
      paste: 'Вставить',
      duplicate: 'Дублировать',
      delete: 'Удалить',
      selectAll: 'Выделить всё',
      group: 'Сгруппировать',
      ungroup: 'Разгруппировать',
      lock: 'Заблокировать',
      front: 'На передний план',
      back: 'На задний план',
      nudge: 'Сдвинуть (Shift — на 10)',
      edit: 'Редактировать текст',
      mmChild: 'Mind map: дочерний / соседний',
      pan: 'Перемещение по доске',
      zoom: 'Масштаб',
      zoomIn: 'Приблизить',
      zoomOut: 'Отдалить',
      zoom100: 'Масштаб 100%',
      fit: 'Показать всё',
      search: 'Поиск по доске',
      chat: 'Чат у курсора',
      help: 'Эта справка',
      cancel: 'Отмена / снять выделение',
    },
  },
  landing: {
    title: 'Думайте вместе на бесконечной доске',
    subtitle:
      'miroom — бесплатная онлайн-доска для команд: стикеры, схемы, mind map, голосование и живые курсоры. Без установки и ограничений по количеству досок.',
    cta: 'Начать бесплатно',
    ctaBoards: 'Открыть мои доски',
    login: 'У меня есть аккаунт',
    why: {
      title: 'Почему miroom',
      formulaLabel: 'Miro плюс Room равно miroom',
      text: 'Название созвучно с Miro, а Room — это комната. miroom — ваша совместная рабочая комната: открываете доску, зовёте команду и думаете вместе, как за одним столом.',
    },
    featuresTitle: 'Всё, что нужно для совместной работы',
    features: {
      realtime: {
        title: 'Работа в реальном времени',
        text: 'Курсоры, правки и выделения участников видны мгновенно — без конфликтов и перезагрузок.',
      },
      tools: {
        title: 'Все инструменты под рукой',
        text: 'Стикеры, фигуры, линии, рисование, таблицы, карточки, mind map и изображения.',
      },
      facilitation: {
        title: 'Воркшопы без хаоса',
        text: 'Голосование, таймер, «следовать за мной», реакции и режим презентации по фреймам.',
      },
      templates: {
        title: 'Готовые шаблоны',
        text: 'Ретро, канбан, user story map, SWOT, lean canvas, роадмап и другие.',
      },
      share: {
        title: 'Простой доступ',
        text: 'Поделитесь ссылкой — гости присоединятся без регистрации. Роли и приглашения по email.',
      },
      export: {
        title: 'Экспорт и история',
        text: 'PNG, SVG, PDF и резервные копии. История версий с восстановлением в один клик.',
      },
    },
    templatesTitle: 'Начните с шаблона',
    bottomTitle: 'Соберите команду на одной доске',
    bottomText: 'Создание доски занимает секунду.',
    footer: 'miroom — свободная альтернатива онлайн-доскам',
    demo: { idea: 'Идея!', vote: 'Голосуем', launch: 'Запуск в пятницу', plan: 'План спринта' },
  },
  settings: {
    title: 'Профиль и настройки',
    profile: 'Профиль',
    name: 'Имя',
    color: 'Цвет аватара',
    email: 'Email',
    save: 'Сохранить',
    saved: 'Профиль сохранён',
    appearance: 'Оформление',
    emailMismatch: 'Email не совпадает с адресом аккаунта',
    sessions: 'Сеансы',
    sessionsText: 'Выход из аккаунта на всех устройствах и в браузерах, включая этот.',
    logoutAll: 'Выйти на всех устройствах',
    danger: 'Удаление аккаунта',
    dangerText: 'Будут удалены аккаунт и все ваши доски. Это действие необратимо.',
    deleteAccount: 'Удалить аккаунт',
    deleteConfirmTitle: 'Удалить аккаунт навсегда?',
    deleteConfirmText: 'Введите email аккаунта, чтобы подтвердить удаление.',
    back: 'К доскам',
  },
  crash: {
    title: 'Что-то пошло не так',
    text: 'Мы уже знаем об ошибке. Обновите страницу — ваши доски сохранены.',
    reload: 'Обновить страницу',
  },
  notFound: {
    title: 'Страница не найдена',
    text: 'Возможно, ссылка устарела или в ней опечатка.',
    home: 'На главную',
  },
};

export type Dictionary = typeof ru;
